var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-submit hover",style:(_vm.submitStyle),on:{"click":_vm.onClick}},[_c('input',{staticClass:"input-submit fonts_kan415typos-std",attrs:{"type":"submit"},domProps:{"value":_vm.label}})])}
var staticRenderFns = []

export { render, staticRenderFns }